<template>
  <StatusChip v-bind="$attrs" title="File Version" :closeOnContentClick="false" :text="versionStatus.text" :icon="versionStatus.icon" :iconColor="versionStatus.iconColor">
    <template #actions>
      <v-list-tile v-for="(version, index) in fileVersions" :class="{ 'card-bg-2': version.isCurrent }" :inactive="version.isCurrent" :key="index" @click="onClick(version)">
        <v-list-tile-avatar>
          <v-tooltip v-if="version.isIngested" bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" :color="version.hasIngestionError ? 'error' : 'info'" v-html="version.hasIngestionError ? 'cloud_off' : 'cloud_done'" />
            </template>
            <span v-if="version.hasIngestionError">This data file could not be ingested.</span>
            <span v-else>This data file was ingested successfully.</span>
          </v-tooltip>
        </v-list-tile-avatar>
        <v-list-tile-title class="clickable">
          {{ getVersionDate(version) }}
          <span class="info--text pl-1" v-if="version.isCurrent">(current)</span>
          <span class="pl-1" v-else-if="index == 0">(latest)</span>
        </v-list-tile-title>
      </v-list-tile>
    </template>
  </StatusChip>
</template>

<script>
  import { precisePrettyDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'
  export default {
    props: {
      fileVersions: Array,
      isLatestVersion: Boolean,
    },
    computed: {
      versionStatus() {
        //if (!this.fileVersions) return 'pending'
        let version = this.isLatestVersion ? {
          text: 'Latest',
          icon: 'done',
          iconColor: 'success',
        } : {
          text: 'A newer version exists',
          icon: 'warning',
          iconColor: 'warning',
        }

        return version
      },

    },
    methods: {
      onClick(version) {
        this.$emit('click:version', version)
      },
      getVersionDate(version) {
        return formatDate(version.dateCreated, precisePrettyDateTimeFormat, { isUtc: true })
      },
    },
  }
</script>